// extracted by mini-css-extract-plugin
export default {"shimmerDefault":"Shimmer_shimmerDefault__6L6-l","shimmer-animation":"Shimmer_shimmer-animation__fbOkY"};